import React, { FC } from "react";
import { Container as MuiContainer, ContainerProps } from "@mui/material";


const Container: FC<ContainerProps> = (props) => {
    return <MuiContainer {...props} maxWidth={false}/>
}

export default Container;